import axios from 'axios';

const DEFAULT_API_KEY = 'AIzaSyBOXXIZctfygUGaUnY_4ycTHqyYv2dT1Ig';

// Blacklisted channels
const BLACKLISTED_CHANNELS = [
  'Pinkfong',
  'Baby Shark Official',
  'Pinkfong Baby Shark',
  'BRIGHT SIDE'
];

// Approved Roblox content creators
const APPROVED_ROBLOX_CREATORS = [
  'TheDevKing',
  'AlvinBlox',
  'GnomeCode',
  'TheDevToys',
  'KhanBlaze',
  'CodingWithPears',
  'SpeedyTutorials',
  'Ludius'
];

export const EDUCATIONAL_CHANNELS = [
  // General Education
  'Khan Academy',
  'Crash Course',
  'TED-Ed',
  'Vsauce',
  'SciShow',
  'Kurzgesagt',
  'edX',
  'Coursera',
  // Math & Physics
  'MinutePhysics',
  'Veritasium',
  '3Blue1Brown',
  'PatrickJMT',
  'MathBFF',
  'Physics Girl',
  // Chemistry & Biology
  'The Organic Chemistry Tutor',
  'Tyler DeWitt',
  'Professor Dave Explains',
  'Bozeman Science',
  // Programming & Tech
  'Traversy Media',
  'freeCodeCamp',
  'Codecademy',
  'MIT OpenCourseWare',
  'Bro Code',
  'The Net Ninja',
  'Web Dev Simplified',
  'Programming with Mosh',
  'Fireship',
  // History & Culture
  'Overly Sarcastic Productions',
  'Extra Credits',
  'PBS',
  'Smithsonian Channel',
  'BBC Learning',
  'National Geographic',
  'World History',
  // General Science
  'AsapSCIENCE',
  'Science Channel',
  'Numberphile',
  'Computerphile',
  'TheDevKing',
  'AlvinBlox',
  'GnomeCode',
  'TheDevToys',
  'KhanBlaze',
  'CodingWithPears',
  'SpeedyTutorials'
];

// Popular video game characters and franchises to block
const BLOCKED_GAME_CHARACTERS = [
  'mario',
  'super mario',
  'luigi',
  'bowser',
  'princess peach',
  'sonic',
  'sonic the hedgehog',
  'tails',
  'knuckles',
  'pokemon',
  'pikachu',
  'zelda',
  'link',
  'ganon',
  'kirby',
  'minecraft steve',
  'pac-man',
  'donkey kong',
  'mega man',
  'master chief',
  'halo',
  'samus',
  'metroid',
  'crash bandicoot',
  'spyro',
  'final fantasy',
  'kingdom hearts',
  'sora',
  'metal gear',
  'solid snake',
  'street fighter',
  'ryu',
  'mortal kombat'
];

// Keywords that indicate non-educational content
const ENTERTAINMENT_KEYWORDS = [
  // Gaming
  'video game',
  'gaming montage',
  'boss fight',
  'nintendo',
  'playstation',
  'xbox',
  'sega',
  'game character',
  'character reveal',
  'character trailer',
  'dlc character',
  'smash bros',
  'super smash',
  'minecraft gameplay',
  'fortnite',
  'fortnite gameplay',
  'fortnite battle royale',
  'fortnite live',
  'fortnite montage',
  'fortnite chapter',
  'fortnite season',
  'gta gameplay',
  'call of duty',
  'cod gameplay',
  'pubg',
  'among us',
  'valorant',
  'apex legends',
  'league of legends',
  'overwatch',
  'pokemon go',
  'genshin impact',
  'gaming',
  'playthrough',
  'walkthrough',
  'game review',
  'lets play',
  'speedrun',
  'stream highlights',
  'gamer',
  'dragon',
  'gameplay',
  'stream',
  // Shorts and Related
  '#shorts',
  '#short',
  '#ytshorts',
  '#shortsvideo',
  'shorts',
  'tiktok',
  'reels',
  // Music & Entertainment
  'music video',
  'lyrics',
  'song',
  'concert',
  'album',
  'mv',
  'funny',
  'prank',
  'reaction',
  'vlog',
  'challenge',
  'meme',
  'entertainment',
  'mukbang',
  'asmr',
  'unboxing',
  'animation movie',
  'cartoon',
  'amv',
  'compilation',
  'montage',
  'highlights',
  'streaming',
  'how to train your dragon'
];

// Programming/Development exceptions that override entertainment keywords
const PROGRAMMING_EXCEPTIONS = [
  // Fortnite UEFN exceptions
  'fortnite uefn',
  'unreal editor for fortnite',
  'fortnite creative 2.0',
  'fortnite development',
  'fortnite creator',
  // Roblox exceptions
  'code roblox studio',
  'roblox studio development',
  'roblox scripting',
  'minecraft mod development',
  'minecraft plugin development',
  'game development tutorial',
  'unity tutorial',
  'unreal engine tutorial',
  'game programming',
  'modding tutorial',
  'coding tutorial',
  'programming guide',
  'development tutorial',
  'lua scripting',
  'game engine development'
];

// Keywords that indicate educational content
const EDUCATIONAL_KEYWORDS = [
  'learn',
  'education',
  'course',
  'tutorial',
  'lesson',
  'lecture',
  'explained',
  'introduction',
  'guide',
  'basics',
  'how to',
  'what is',
  'history',
  'documentary',
  'biography',
  'science',
  'math',
  'engineering',
  'literature',
  'art',
  'culture',
  'analysis',
  'research',
  'study',
  'experiment',
  'academic',
  'physics',
  'chemistry',
  'biology',
  'calculus',
  'algebra',
  'geometry',
  'theorem',
  'theory',
  'concept',
  'solution',
  'problem',
  'exercise',
  'practice',
  'example',
  'review',
  'code',
  'program',
  'develop',
  'javascript',
  'python',
  'java',
  'html',
  'css',
  'programming',
  'coding',
  'software',
  'web',
  'app',
  'database',
  'algorithm',
  'data structure'
];

export interface Video {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  channel: string;
  views: string;
  publishedAt: string;
  isEducational: boolean;
}

export const formatDuration = (duration: string) => {
  const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  
  const hours = (match?.[1] || '').replace('H', '');
  const minutes = (match?.[2] || '').replace('M', '');
  const seconds = (match?.[3] || '').replace('S', '');

  let result = '';
  if (hours) result += hours + ':';
  result += (minutes || '0').padStart(2, '0') + ':';
  result += (seconds || '0').padStart(2, '0');
  
  return result;
};

export const formatViews = (viewCount: string) => {
  const views = parseInt(viewCount);
  if (views >= 1000000) {
    return `${(views / 1000000).toFixed(1)}M views`;
  } else if (views >= 1000) {
    return `${(views / 1000).toFixed(1)}K views`;
  }
  return `${views} views`;
};

export const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const searchYouTube = async (
  query: string, 
  apiKey?: string
): Promise<{ videos: Video[], message?: string }> => {
  const YOUTUBE_API_KEY = apiKey || DEFAULT_API_KEY;
  const queryLower = query.toLowerCase();
  const isRobloxSearch = queryLower.includes('roblox');
  
  try {

    const response = await axios.get('https://www.googleapis.com/youtube/v3/search', {
      params: {
        part: 'snippet',
        maxResults: 25,
        q: query,
        type: 'video',
        key: YOUTUBE_API_KEY,
        videoDuration: 'any',
        safeSearch: 'strict',
        videoEmbeddable: true,
        videoSyndicated: true,
        order: 'relevance'
      }
    });

    const videoIds = response.data.items.map((item: any) => item.id.videoId).join(',');
    
    const videoDetailsResponse = await axios.get('https://www.googleapis.com/youtube/v3/videos', {
      params: {
        part: 'contentDetails,snippet,statistics',
        id: videoIds,
        key: YOUTUBE_API_KEY
      }
    });

    const videos = videoDetailsResponse.data.items
      .map((item: any) => {
        const title = item.snippet.title.toLowerCase();
        const description = item.snippet.description.toLowerCase();
        const channelTitle = item.snippet.channelTitle;

        // Check for blacklisted channels first
        const isBlacklisted = BLACKLISTED_CHANNELS.some(channel =>
          channelTitle.toLowerCase().includes(channel.toLowerCase())
        );
        if (isBlacklisted) {
          return null;
        }

        // For Roblox searches, only show approved creators
        if (isRobloxSearch) {
          const isApprovedRobloxCreator = APPROVED_ROBLOX_CREATORS.some(creator =>
            channelTitle.toLowerCase().includes(creator.toLowerCase())
          );
          
          // Skip all other checks for Roblox searches
          if (!isApprovedRobloxCreator) {
            return null;
          }

          return {
            id: item.id,
            title: item.snippet.title,
            thumbnail: item.snippet.thumbnails.high.url,
            duration: formatDuration(item.contentDetails.duration),
            channel: channelTitle,
            views: formatViews(item.statistics.viewCount),
            publishedAt: formatDate(item.snippet.publishedAt),
            isEducational: true // Approved Roblox creators are considered educational
          };
        }

        // For Fortnite content, only allow UEFN-related content
        const isFortniteContent = title.includes('fortnite') || description.includes('fortnite');
        if (isFortniteContent) {
          const isUEFNContent = PROGRAMMING_EXCEPTIONS.some(keyword =>
            title.includes(keyword.toLowerCase()) || description.includes(keyword.toLowerCase())
          );
          if (!isUEFNContent) {
            return null;
          }
        }

        // Non-Roblox content checks
        const isEducationalChannel = EDUCATIONAL_CHANNELS.some(channel =>
          channelTitle.toLowerCase().includes(channel.toLowerCase())
        );

        const hasEducationalKeywords = EDUCATIONAL_KEYWORDS.some(keyword =>
          title.includes(keyword.toLowerCase()) || description.includes(keyword.toLowerCase())
        );

        const isProgrammingContent = PROGRAMMING_EXCEPTIONS.some(keyword =>
          title.includes(keyword.toLowerCase()) || description.includes(keyword.toLowerCase())
        );

        const isShort = (
          ['#shorts', '#short', '#ytshorts', 'shorts', 'tiktok', 'reels'].some(keyword => 
            title.includes(keyword.toLowerCase()) || description.includes(keyword.toLowerCase())
          ) ||
          item.contentDetails.duration.match(/PT[0-5][0-9]S/)
        );

        // Check for blocked game characters
        const hasBlockedCharacters = BLOCKED_GAME_CHARACTERS.some(character =>
          title.includes(character.toLowerCase()) || description.includes(character.toLowerCase())
        );

        const hasEntertainmentKeywords = ENTERTAINMENT_KEYWORDS.some(keyword =>
          title.includes(keyword.toLowerCase()) || description.includes(keyword.toLowerCase())
        );

        const isEducational = !isShort && !hasBlockedCharacters && 
          (isEducationalChannel || hasEducationalKeywords) &&
          (isProgrammingContent || !hasEntertainmentKeywords);


        return {
          id: item.id,
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.high.url,
          duration: formatDuration(item.contentDetails.duration),
          channel: channelTitle,
          views: formatViews(item.statistics.viewCount),
          publishedAt: formatDate(item.snippet.publishedAt),
          isEducational
        };
      })
      .filter((video: Video | null): video is Video => video !== null && video.isEducational)
      .slice(0, 12);

    return {
      videos,
      message: videos.length === 0 ? "Edutube only serves educational videos" : undefined
    };

  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw new Error(err.response?.data?.error?.message || 'Failed to fetch videos');
    }
    throw new Error('An unexpected error occurred');
  }
};
